import { useState } from 'react'
import { translations } from '../../configs/translations'
import { Language } from '../../context/LanguageContext'
import { RaceTypes } from '../../enums/RaceTypes'
import './ModeSelector.css'

interface ModeSelectorProps {
    selectedMode: RaceTypes
    modes: Record<string, Record<string, string>>
    onModeChange: (mode: RaceTypes) => void
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({ selectedMode, modes, onModeChange }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const arrowIcon = (
        <svg
            className={`mode-selector-arrow ${isOpen ? 'open' : ''}`}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z"
                fill="white"
            />
        </svg>
    )

    const modeToString = {
        [RaceTypes.FREEROOM]: t.free_mode,
        [RaceTypes.RANKED]: t.rating_race,
        [RaceTypes.UNRANKED]: t.random_race,
        [RaceTypes.TRAINING]: t.training,
        [RaceTypes.GHOST]: t.ghost_race,
    }

    const handleModeChange = (modeStr: string) => {
        if (modeStr === t.free_mode) {
            onModeChange(RaceTypes.FREEROOM)
        } else if (modeStr === t.rating_race) {
            onModeChange(RaceTypes.RANKED)
        } else if (modeStr === t.random_race) {
            onModeChange(RaceTypes.UNRANKED)
        } else if (modeStr === t.training) {
            onModeChange(RaceTypes.TRAINING)
        } else if (modeStr === t.ghost_race) {
            onModeChange(RaceTypes.GHOST)
        }
    }

    const freeMode = modes.freeroam
    const rankedMode = modes.ranked
    const unrankedMode = modes.unranked
    const training = modes.training
    const ghostMode = modes.ghost

    return (
        <div className="mode-selector-container">
            <button
                className="mode-selector-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="mode-selector-text">{modeToString[selectedMode]}</span>
                {arrowIcon}
            </button>
            {isOpen && (
                <div className="mode-selector-content">
                    {Object.values(unrankedMode).map((value) => (
                        <div
                            key={value}
                            className="mode-selector-item"
                            onClick={() => {
                                handleModeChange(value)
                                setIsOpen(false)
                            }}
                        >
                            <span className="mode-selector-item-text">{value}</span>
                        </div>
                    ))}
                    <div style={{ height: '10px' }} />
                    {Object.values(ghostMode).map((value) => (
                        <div
                            key={value}
                            className="mode-selector-item"
                            onClick={() => {
                                handleModeChange(value)
                                setIsOpen(false)
                            }}
                        >
                            <span className="mode-selector-item-text">{value}</span>
                        </div>
                    ))}
                    <div style={{ height: '10px' }} />
                    {Object.values(rankedMode).map((value) => (
                        <div
                            key={value}
                            className="mode-selector-item"
                            onClick={() => {
                                handleModeChange(value)
                                setIsOpen(false)
                            }}
                        >
                            <span className="mode-selector-item-text">{value}</span>
                        </div>
                    ))}
                    <div style={{ height: '10px' }} />
                    {Object.values(freeMode).map((value) => (
                        <div
                            key={value}
                            className="mode-selector-item"
                            onClick={() => {
                                handleModeChange(value)
                                setIsOpen(false)
                            }}
                        >
                            <span className="mode-selector-item-text">{value}</span>
                        </div>
                    ))}
                    {Object.values(training).map((value) => (
                        <div
                            key={value}
                            className="mode-selector-item"
                            onClick={() => {
                                handleModeChange(value)
                                setIsOpen(false)
                            }}
                        >
                            <span className="mode-selector-item-text">{value}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
} 